query GetTerritories {
    territories {
        edges {
            node {
                id
                name
            }
        }
    }
}
